module.exports = __webpack_public_path__ + "static/img/dd-customer-10.55281e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-customer-10.jpg
// module id = cADJ
// module chunks = 1